import { Option, Schema } from "effect";

export const LEARNING_STEPS = ["10m"] as const;
export const RELEARNING_STEPS = ["10m"] as const;

export type SteppedTag = "learning" | "relearning";

export const stepsOf = (tag: SteppedTag) => (tag === "learning" ? LEARNING_STEPS : RELEARNING_STEPS);

export const Step = Schema.Int.check(Schema.isGreaterThanOrEqualTo(0)).pipe(Schema.brand("Step"));
export type Step = typeof Step.Type;

export function stepFor(tag: SteppedTag, n: number): Option.Option<Step> {
  return n < stepsOf(tag).length ? Step.makeOption(n) : Option.none();
}
